import {
  CreatePaymentOrderRequest,
  CreatePaymentOrderResponse,
  CreditProductResponse,
  CreditTransactionQuery,
  CreditTransactionRow,
  PaginatedResponse,
  PaginationQuery,
  PaymentOrderResponse,
  UserCreditAccountResponse,
} from "@packages/global";
import { httpClient } from "../httpClient";

export class PaymentsApi {
  async products(): Promise<CreditProductResponse[]> {
    return httpClient.get<CreditProductResponse[]>("/user/payments/products");
  }

  async publicProducts(): Promise<CreditProductResponse[]> {
    return httpClient.get<CreditProductResponse[]>("/payments/products");
  }

  async createOrder(data: CreatePaymentOrderRequest): Promise<CreatePaymentOrderResponse> {
    return httpClient.post<CreatePaymentOrderResponse>("/user/payments/orders", data);
  }

  async getOrder(id: string): Promise<PaymentOrderResponse> {
    return httpClient.get<PaymentOrderResponse>(`/user/payments/orders/${id}`);
  }

  async creditAccount(): Promise<UserCreditAccountResponse> {
    return httpClient.get<UserCreditAccountResponse>("/user/api/credits/account");
  }

  async creditTransactions(queryData: PaginationQuery<CreditTransactionQuery>): Promise<PaginatedResponse<CreditTransactionRow>> {
    return httpClient.post<PaginatedResponse<CreditTransactionRow>>("/user/api/credits/transactions/page", queryData);
  }
}

export const paymentsApi = new PaymentsApi();
